import { financialFramesActions } from './slice';
import { FinancialFrameUpdate } from './stateType';

export const fetchFinancialFrames =
  financialFramesActions.fetchFinancialFrames as () => void;

export const updateFinancialFrame =
  financialFramesActions.updateFinancialFrame as (payload: {
    id: number;
    body: FinancialFrameUpdate;
  }) => void;
